import React, { Component } from 'react'
import FaClip from 'react-icons/lib/fa/clipboard'
import FaCheck from 'react-icons/lib/fa/check'
import EmbedIcon from 'react-icons/lib/go/gear'
import { getEmbedCode } from '../../../misc/utilities'
import { cancel, generateEmbedCode } from '../../../actions'
import Cookies from 'js-cookie'
import { browserHistory } from 'react-router'
import ClipboardButton from 'react-clipboard.js'


export default class GridItem extends Component {
  constructor() {
    super()

    this.state = {
      clipped: false,
    }

    this.getEmbedOptions = this.getEmbedOptions.bind(this)
  }

  getEmbedOptions() {
    const storedOpts = JSON.parse(Cookies.get('embed_options') || '{}')
    return {
      responsive: true,
      ...storedOpts,
      source: 'dashboard-1click',
      id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6),
    }
  }

  render() {
    const pro = false
    const {
      video,
      dispatch,
      toggleEmbedModal,
      group,
      toggleDeleteModal,
      className,
    } = this.props
    const self = this
    return (
      <span className={`video-action-buttons ${className}`}>
        {video.height && video.width
          ? 
            pro ?
              <button
                className={
                    `btn button-primary action-button`
                  }
                onClick={() => {
                  browserHistory.push(`/buildembed/${video.shortcode}`)
                }}
              >
                Embed
              </button>
            :
              <div className={`btn-group action-button float-right ${self.state.clipped ? 'clipped' : ''}`}>
                <button
                  className={
                      `btn button-primary action-button ${self.state.clipped ? 'clipped' : ''}`
                    }
                  onClick={() => {
                    toggleEmbedModal()
                  }}
                  style={{ padding: '0px 6px' }}
                >
                  <EmbedIcon />
                </button>
                <ClipboardButton
                  ref="embedButton"
                  component="button"
                  className={`btn button-primary ${self.state.clipped ? 'clipped' : ''}`}
                  option-text={() => {
                    const options = self.getEmbedOptions()
                    dispatch(
                        generateEmbedCode({
                          video,
                          ...options,
                        }),
                      )
                    return getEmbedCode(video, options)
                  }}
                  onSuccess={() => {
                    window.ga('send', 'event', 'Embeds', 'copied', 'dashboard')
                    self.setState({ clipped: true })
                    setTimeout(
                        () => {
                          self.setState({ clipped: false })
                        },
                        5000,
                      )
                  }}
                  onError={() => {
                    toggleEmbedModal()
                  }}
                >
                  {self.state.clipped
                      ? <span>
                          Copied
                          {' '}
                        <FaCheck
                          style={{
                            fontSize: '12px',
                            marginLeft: '4px',
                          }}
                        />
                      </span>
                      : <span>
                          Embed
                          {' '}
                        <FaClip
                          style={{
                            fontSize: '12px',
                            marginLeft: '4px',
                          }}
                        />
                      </span>}
                </ClipboardButton>
              </div>
          : ''}
        {video.status == null || video.status < 2
          ? <button
            className="action-button float-right"
            onClick={() => {
              dispatch(cancel(video))
            }}
          >
              Cancel
            </button>
          : <div className="float-right">
              <button
                className="action-button float-right"
                onClick={() => {
                  browserHistory.push(`/edit/${video.shortcode}`)
                }}
              >
                Edit Video
              </button>
          </div>}
      </span>
    )
  }
}